import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getWeather from './actions/getWeather'
import getWeatherTypes from "./actions/getWeatherTypes"
import resetWeather from "./actions/resetWeather"
import Weather from './components/index'
import resetError from "shared/errorHandler/actions/resetError"

const mapStateToProps = (state) => {
    return ({
        error: state.error.message,
        username: state.user.username,
        data: state.weather.data,
        types: state.weather.types,
        isLoadingTypes: state.weather.isLoadingTypes,
        isLoading: state.weather.isLoading
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getWeather,
        getWeatherTypes,
        resetWeather,
        resetError
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Weather))



// WEBPACK FOOTER //
// ./src/screens/weather/index.js